import Card from "../components/Card";
import { useTranslation } from "react-i18next";

export default function MedicoverOnboardingLanding() {
  const { t } = useTranslation();

  return (
    <div className="max-w-3xl mx-auto px-4 py-6">
      <h1 className="text-2xl font-bold text-slate-900 mb-2">{t("onboarding.title", "Bun venit în ZeroRiscuri")}</h1>
      <p className="text-slate-500 mb-6">{t("medicover.message", "În prezent configurăm accesul pentru Medicover. Platforma este în proces de onboarding, iar accesul la funcționalități este limitat momentan. Îți mulțumim pentru răbdare.")}</p>

      <Card>
        <div className="py-8 text-center">
          <h2 className="text-xl font-semibold text-slate-900 mb-2">{t("medicover.status_title", "Access limitat")}</h2>
          <p className="text-sm text-slate-500 mb-4">{t("medicover.status_sub", "Vei putea folosi platforma imediat ce procesul de configurare este finalizat.")}</p>
          <div className="mt-4 text-sm text-slate-500">{t("medicover.contact_hint", "Revenim cu detalii în curând.")}</div>
        </div>
      </Card>
    </div>
  );
}
